import { Button, Col, Form, Input, message, Row } from "antd";
import { useForm } from "antd/lib/form/Form";
import axios from "axios";
import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const { TextArea } = Input;

function FormComp() {
  const [isLoading, setIsLoading] = useState();
  const [verfied, setVerifed] = useState(false);

  const [form] = useForm();

  const onFinish = (values) => {
    setIsLoading(true);
    axios
      .post("https://dark-jade-perch-cuff.cyclic.app/contact", {
        email: values.email,
        username: values?.username,
        phone: values.phone,
        website: values?.website,
        messsage: values?.help,
      })
      .then(
        (response) => {
          form.resetFields();
          message.success("Your Information Sent Sucessfully!");
          setIsLoading(false);
        },
        (error) => {
          message.error(error?.response?.data.message);
        }
      );
  };

  // recapthca onChange
  const onChange = (value) => {
    console.log(value);
    setVerifed(true);
  };

  return (
    <div className="my-[60px] max-w-[1750px] form_comp">
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={9} xxl={9}>
          <div className="h-full w-full flex items-center justify-center">
            <img
              width="100%"
              height="80%"
              src="/assets/contact_img.svg"
              alt=""
            />
          </div>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={13} xxl={13}>
          <div className="bg-[#161616] px-[30px] py-[15px] w-full h-[720px]">
            <div className="text-[48px] text-[#ffffff] font-bold max-[481px]:text-[18px] text-center py-6">
              Send A Message
              <div className="mt-[10px] max-[481px]:mt-[30px]">
                <Form
                  form={form}
                  name="basic"
                  onFinish={onFinish}
                  initialValues={{ remember: true }}
                  autoComplete="off"
                  layout="vertical"
                >
                  <div className="w-full flex items-center justify-between">
                    <Form.Item
                      label="Name"
                      name="username"
                      className="w-[48%]"
                      rules={[
                        {
                          required: true,
                          message: "Please input your name!",
                        },
                      ]}
                    >
                      <Input
                        className="h-[40px]"
                        type="text"
                        disabled={isLoading}
                      />
                    </Form.Item>

                    <Form.Item
                      label="Email"
                      name="email"
                      className="w-[48%]"
                      rules={[
                        {
                          required: true,
                          message: "Please input your email!",
                        },
                      ]}
                    >
                      <Input
                        className="h-[40px]"
                        type="email"
                        disabled={isLoading}
                      />
                    </Form.Item>
                  </div>
                  <Form.Item
                    label="Website"
                    name="website"
                    rules={[
                      {
                        required: false,
                      },
                    ]}
                  >
                    <Input
                      className="h-[40px]"
                      type="text"
                      disabled={isLoading}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Phone"
                    name="phone"
                    rules={[
                      {
                        required: true,
                        message: "Please input your phone!",
                      },
                    ]}
                  >
                    <Input
                      className="h-[40px]"
                      type="text"
                      disabled={isLoading}
                    />
                  </Form.Item>
                  <Form.Item
                    label="How Can We Help You?"
                    name="help"
                    rules={[
                      {
                        required: false,
                      },
                    ]}
                  >
                    <TextArea rows={4} disabled={isLoading} />
                  </Form.Item>
                  <div className="flex justify-center mb-4">
                    <ReCAPTCHA
                      sitekey="6Le7R20jAAAAACKkAR1QYIFEQebkWNV6kuaJvRQF"
                      onChange={onChange}
                    />
                  </div>
                  <Form.Item className="text-center">
                    <Button
                      className="!bg-[white] !text-[#1F2023] !font-bold !h-[40px] !border-none"
                      type="primary"
                      htmlType="submit"
                      disabled={isLoading || !verfied}
                    >
                      {isLoading ? "Submiting" : "Submit"}
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default FormComp;
